import { isArray } from '@dazn/peng-html5-tools-utils';
var parseDevelopmentPackages = function (developmentPackageNames, withoutPorts) {
    var _a;
    if (developmentPackageNames === void 0) { developmentPackageNames = []; }
    if (!developmentPackageNames)
        return [];
    // process.env contains strings, not arrays, we need to check for both, because webpack Env plugin passes arrays
    var devPackages = isArray(developmentPackageNames)
        ? developmentPackageNames
        : ((_a = developmentPackageNames === null || developmentPackageNames === void 0 ? void 0 : developmentPackageNames.split(',')) !== null && _a !== void 0 ? _a : []);
    if (withoutPorts) {
        devPackages = devPackages.map(function (devPackageNameAndPort) { return devPackageNameAndPort.split(':')[0]; });
    }
    return devPackages;
};
export { parseDevelopmentPackages };
//# sourceMappingURL=parseDevelopmentPackages.js.map